"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Phone, MessageCircle, Send } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Separator } from "@/components/ui/separator";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const defaultMascot = {
  name: "ROBOTO Mascot",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/af0573d1-cac5-46e2-816e-4e00b0b25dc3-1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/af0573d1-cac5-46e2-816e-4e00b0b25dc3-1.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1806685/img/af0573d1-cac5-46e2-816e-4e00b0b25dc3-1.png-wvc-sizes"
};
export default function Consultation() {
  const shouldReduceMotion = useReducedMotion();
  const channels = [{
    name: "Zalo",
    status: "Sắp cập nhật",
    icon: MessageCircle,
    disabled: true
  }, {
    name: "Messenger",
    status: "Sắp cập nhật",
    icon: Send,
    disabled: true
  }];
  return <section id="curriculumconsultationcta" data-nav="light" className="relative w-full bg-background border-y border-border">
      <div className="bg-muted/40 w-full py-8 md:py-10">
        <div className="max-w-7xl mx-auto px-6 relative">
          {/* Static Floating Decorative Mascot */}
          <div aria-hidden="true" className="absolute -top-9 sm:-top-12 lg:-top-14 right-3 sm:right-6 lg:right-8 z-10 pointer-events-none select-none">
            <img src={defaultMascot.src} data-wvc-srcset={defaultMascot.srcset} data-wvc-sizes={defaultMascot.sizes} alt="" loading="lazy" className="w-14 h-14 sm:w-20 sm:h-20 md:w-24 md:h-24 lg:w-28 lg:h-28 object-contain bg-transparent pointer-events-none select-none drop-shadow-md" />
          </div>

          <motion.div initial={shouldReduceMotion ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.35,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col lg:flex-row items-center justify-between gap-6">
            {/* Left side: Heading */}
            <div className="text-center lg:text-left max-w-xl">
              <h2 className="font-serif text-xl sm:text-2xl font-semibold text-foreground tracking-normal">
                Bạn chưa biết lộ trình nào phù hợp với con?
              </h2>
            </div>

            {/* Right side: Action & Quick Contact Cluster */}
            <div className="flex flex-wrap items-center justify-center lg:justify-end gap-3 sm:gap-4">
              {/* Primary Consultation Trigger */}
              <motion.div whileHover={shouldReduceMotion ? {} : {
              scale: 1.02
            }} whileTap={shouldReduceMotion ? {} : {
              scale: 0.98
            }} className="shrink-0">
                <Button asChild className="bg-accent text-accent-foreground font-semibold px-6 py-3 rounded-lg shadow-sm hover:brightness-95 transition-[color,box-shadow,filter]">
                  <Link to="/FreeTrialContactPage">
                    ĐĂNG KÝ TƯ VẤN
                  </Link>
                </Button>
              </motion.div>

              {/* Vertical separator on larger screens */}
              <div className="hidden sm:block h-6">
                <Separator orientation="vertical" className="bg-border h-full" />
              </div>

              {/* Quick Contact Options */}
              <div className="flex items-center gap-2 sm:gap-3">
                <TooltipProvider delayDuration={150}>
                  {channels.map((channel, idx) => {
                  const IconComponent = channel.icon;
                  return <div key={channel.name} data-index={idx}>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <span tabIndex={0} className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-border bg-background/50 text-xs font-medium text-muted-foreground opacity-60 cursor-not-allowed select-none transition-colors">
                              <IconComponent className="size-3.5" />
                              <span>{channel.name}</span>
                              <Badge variant="outline" className="text-[10px] py-0 px-1.5 h-4 bg-muted text-muted-foreground border-transparent font-normal">
                                {channel.status}
                              </Badge>
                            </span>
                          </TooltipTrigger>
                          <TooltipContent side="top">
                            <span>Kênh {channel.name} sắp được hỗ trợ</span>
                          </TooltipContent>
                        </Tooltip>
                      </div>;
                })}
                </TooltipProvider>

                {/* Direct Hotline link */}
                <Button asChild variant="outline" size="sm" className="rounded-full border-border bg-background text-foreground hover:bg-accent hover:text-accent-foreground shadow-2xs font-medium px-3.5 py-1.5 text-xs h-auto gap-1.5">
                  <a href="tel:0346386986" className="flex items-center gap-1.5" aria-label="Gọi hotline tư vấn 0346 386 986">
                    <Phone className="size-3.5 text-accent" />
                    <span>0346 386 986</span>
                  </a>
                </Button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}